module.exports = __webpack_public_path__ + "static/map-estonia-dd235d19fa3696062f199f88d28c4423.png";